module.exports = __webpack_public_path__ + "img/E-WEB-Goal-03.1cebfd41.png";